import { SectionLabel } from "./WhatMakesSpecial";

const features = [
  { icon: "ri-smartphone-line", title: "Dedicated Mobile App", desc: "Rolex9 offers a dedicated app for both iOS and Android devices. Download it directly from the Rolex9 website — no App Store required. Every deposit triggers a random bonus through the app." },
  { icon: "ri-global-line", title: "Full Browser-Based Play", desc: "No app? No problem. The complete Rolex9 casino experience is available directly in your mobile browser. Open Safari or Chrome on any device and play instantly — no download needed." },
  { icon: "ri-speed-line", title: "Fast & Stable Performance", desc: "Rolex9 is built for stable, lag-free performance on mobile. Games load quickly and run smoothly even on slower connections — quality and reliability are core to the platform." },
  { icon: "ri-shield-check-line", title: "Secure Mobile Transactions", desc: "All deposits and withdrawals on mobile are protected by SSL encryption. PayID and OSKO payments are processed securely through Australia&apos;s New Payments Platform." },
  { icon: "ri-notification-3-line", title: "Push Notifications & Updates", desc: "Stay informed about new promotions, bonus credits and platform updates through app push notifications. Never miss a daily rebate or monthly ranking update." },
  { icon: "ri-customer-service-2-line", title: "24/7 Live Chat on Mobile", desc: "Access the full customer support team directly from your mobile device. Live chat is available around the clock — fast, friendly and always responsive." },
];

export default function MobileSection() {
  return (
    <section id="mobile" className="max-w-5xl mx-auto px-6 py-12">
      <SectionLabel>Mobile Gambling</SectionLabel>
      <p className="text-white/40 text-sm leading-relaxed mb-10 max-w-2xl">
        Rolex9 is built for mobile-first Australian players. Download the dedicated app for the full experience, or play instantly in your browser — no restrictions, no compromises, on any iOS or Android device.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {features.map((f, i) => (
          <div
            key={i}
            className="glass-card rounded-xl p-5 flex gap-4 hover:border-[#c9a84c]/15 transition-all duration-300"
            style={{ borderColor: "rgba(255,255,255,0.05)" }}
          >
            <div
              className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0"
              style={{ background: "linear-gradient(135deg, rgba(201,168,76,0.12), rgba(107,33,168,0.12))" }}
            >
              <i className={`${f.icon} text-[#c9a84c] text-lg`}></i>
            </div>
            <div>
              <p className="text-white/70 font-semibold text-sm mb-1" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>{f.title}</p>
              <p className="text-white/30 text-xs leading-relaxed">{f.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
